import CustomerView from "layouts/customer-view";
import { getClientSession, getClientAccessToken } from "utils/clientSession";

export default function ClientCustomerHome() {
  const customerId = getClientSession()?.customerId;
  const clientAccessToken = getClientAccessToken();

  if (!customerId) {
    return null;
  }

  return (
    <CustomerView
      portalVariant="client"
      customerId={customerId}
      clientAccessToken={clientAccessToken}
    />
  );
}
